import { Component, OnInit } from '@angular/core';
import {UserSettingsModalService} from './user-settings-modal.service';

@Component({
  selector: 'app-user-settings-modal',
  templateUrl: './user-settings-modal.component.html',
  styleUrls: ['./user-settings-modal.component.css']
})
export class UserSettingsModalComponent implements OnInit {

  constructor(public modalSv: UserSettingsModalService) { }

  ngOnInit() {

  }

  onCloseIcon() {

    this.modalSv.onHide();

  }

  onSectionChanged(key: string) {

    for (const section of this.modalSv.settingsSections) {
      if (section.key === key) {
        this.modalSv.currentSection = section;
        break;
      }
    }

  }

}
